/**
* 机构-销课修改
*/
<template>
    <div>
        <van-nav-bar placeholder title="销课记录修改" left-text="" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>
        <van-pull-refresh v-model="loading" @refresh="refresh()" style="min-height: 100vh">
            <van-form @submit="onSubmit">
                <div class="yj-box">
                    <div class="box-title">
                        <h2>销课信息</h2>
                        <!--<img src="~@/assets/xl.png">-->
                    </div>
                    <div class="yj-con">
                        <div class="con-list"><span>机构名称：</span><p>{{ curriculumInfo.institutionName }}</p></div>
                        <div class="con-list"><span>课程名称：</span><p>{{ curriculumInfo.name }}</p></div>
                        <div class="con-list"><span>任课教师：</span><p>{{ curriculumInfo.teacherName }}</p></div>
                        <div class="con-list"><span>实际上课时间：</span><p>{{ moment(record.signTime).format("YYYY-MM-DD HH:mm") }}</p></div>
                    </div>
                </div>
                <div  class="yj-box">
                    <div  class="box-title">
                        <h2>学员信息</h2>
                        <!--<img src="~@/assets/xl.png">-->
                    </div>
                    <div class="yj-con">
                        <div class="con-list" v-for="item in applyInfoList" :key="item.id">
                            <span>{{ item.studentName }}</span>
                            <span>{{ item.phone }}</span>
                            <span v-show="item.classHour">{{ item.classHour }}课时</span>
                            <span v-show="item.status">{{ filterLabelName(signStatusOption, item.status) }}</span>
                            <van-stepper v-model="item.signHour" min="0" :max="item.leftHour" theme="round" button-size="20" />
                        </div>
                    </div>
                </div>
                <div style="margin: 16px;">
                    <van-button
                            :loading="submitLoading"
                            v-if="applyInfoList.length > 0"
                            round block type="primary"
                            native-type="submit">
                        保存
                    </van-button>
                </div>
            </van-form>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {signDetailInfo, signModify} from '@/api/course/institutionCourse'
    import {filterLabelName, getDictByType} from '@/api/common'
    import moment from 'moment'

    export default {
        name: 'SignDetailInfo',
        components: {
        },
        data () {
            return {
                filterLabelName,
                moment,
                signId: '',
                signDetailId: '',
                loading: false,
                show: false,
                submitLoading: false,
                id: '',
                curriculumInfo: {},
                record: {},
                signStatusOption: [],
                applyInfoList: []
            }
        },
        computed: {
        },
        created () {
            this.getDict();
            this.signId = this.$route.query.signId;
            this.signDetailId = this.$route.query.signDetailId;
            this.refresh()
        },
        mounted () {
        },
        methods: {
            refresh() {
                this.getDetail()
            },
            getDetail() {
                signDetailInfo({ signId: this.signId, signDetailId: this.signDetailId }).then(res => {
                    if (res.code === 10000) {
                        this.record = res.result || {};
                        this.applyInfoList = this.record.detailList || [];
                        this.curriculumInfo = this.record.curriculumInfo || {}
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                })
            },
            onClickLeft() {
                this.$router.go(-1)
            },
            // 数据字典
            getDict() {
                // 查询字典，销课状态
                getDictByType('sign_status').then(res => {
                    if (res.code === 10000) {
                        this.signStatusOption = res.result.map(item => {
                            return {label: item.dictKey, value: item.dictValue}
                        })
                    }
                });
            },
            onSubmit(){
                this.submitLoading = true;
                if (this.applyInfoList.length < 1){
                    this.$toast("学员信息无数据!");
                    return
                }
                this.applyInfoList.forEach(item => {
                    item.consumerClass = item.signHour
                });
                const data = {
                    signId: this.signId,
                    signDetailId: this.signDetailId,
                    curriculumId: this.record.curriculumId,
                    signTime: this.record.signTime,
                    applyInfoList: this.applyInfoList
                };
                // console.log("参数", data);
                signModify(data).then(res => {
                    if (res.code === 10000) {
                        this.$toast(res.msg);
                        this.$router.push({path: `/institutionCourse/signRecord`});
                    }
                }).finally(() => {
                    this.submitLoading = false;
                })
            }
        }
    }


</script>

<style scoped>
    .yj-box{
        display: flex;
        margin: 0 10px;
        flex-direction: column;
    }
    .box-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height:16px;
        margin-top: 23px;
        margin-bottom: 17px;
    }
    .box-title h2{
        display: flex;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
    }
    .box-title img{
        width: 16px;
        height: 9px;
    }
    .yj-con{
        background: #F4F5F7;
        border-radius:12px;
        display: flex;
        padding: 17px;
        flex-direction: column;
    }
    .con-list{
        display: flex;
        margin-bottom: 15px;
    }
    .con-list:last-child{
        margin-bottom: 0;
    }
    .con-list span{
        display: flex;
        font-size:14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #777777;
        justify-content: flex-end;
        padding-left: 5px;
    }
    .con-list p{
        display: flex;
        flex: 1;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    /deep/.van-uploader__preview-image{
        height: 15vw;
        width:73px;
    }
    .box-style{
        padding-bottom: 20px;
    }
    /deep/.van-stepper--round .van-stepper__minus {
        color: #66C779;
        background-color: #fff;
        border: 1px solid #66C779;
    }
    /deep/.van-stepper--round .van-stepper__plus {
        color: #fff;
        background-color: #66C779;
    }
</style>

